import React, { FC, MutableRefObject, ReactElement, useEffect } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { CallRecIntegration } from '../../../../i18n'
import { useFormContext, UseFormMethods } from '../../../Vendor/react-hook-form/dist/index.ie11'
// Language
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import FormRow from '../../Common/Components/FormRow'
import { ValidationErrors } from '../../Common/Components/ValidationErrors/ValidationErrors'
import { StateSetter } from '../../Common/Types/Types'
import { INTEGRATION_TYPE_VALUES } from '../Constants/Constants'
import { DESCRIPTION_GENERAL_NAME, GUID_GENERAL_NAME, INTEGRATION_GENERAL_NAME } from '../Constants/FieldNames'
import { OutlinedTextInput } from '../../../ReactRouting/Components/Atoms/Inputs/OutlinedTextInput'
import { OutlinedSelect } from '../../../ReactRouting/Components/Atoms/Inputs/OutlinedSelect'

type Props = {
    viewOnly: boolean | undefined
    isCallRecIntegrationSelected: boolean | undefined
    setIntegrationType: StateSetter<number>
}

const General: FC<Props> = ({ viewOnly, isCallRecIntegrationSelected, setIntegrationType }: Props): ReactElement => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle(CallRecIntegration.NAME)

    // Contexts
    const { watch }: UseFormMethods = useFormContext()
    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    const integrationValue: number = watch(INTEGRATION_GENERAL_NAME)

    useEffect(() => {
        if (isMounted.current) {
            setIntegrationType(integrationValue)
        }
    }, [integrationValue])

    const IntegrationTypes = [
        {
            label: language.get(CallRecIntegration.IntegrationType_1),
            value: INTEGRATION_TYPE_VALUES.UNKNOWN
        },
        {
            label: language.get(CallRecIntegration.IntegrationType_2),
            value: INTEGRATION_TYPE_VALUES.DUBBER
        }
    ]

    return (
        <div className='user-details-tab tab-area'>
            <FormRow>
                <ValidationErrors name={GUID_GENERAL_NAME}>
                    <OutlinedTextInput
                        placeholder={language.get(CallRecIntegration.IdentifierGUIDPlaceholder)}
                        labelLeft={language.get(CallRecIntegration.IdentifierGUID)}
                        inputName={GUID_GENERAL_NAME}
                        disabled={viewOnly || isCallRecIntegrationSelected}
                    />
                </ValidationErrors>
            </FormRow>
            <FormRow>
                <OutlinedSelect
                    name={INTEGRATION_GENERAL_NAME}
                    label={language.get(CallRecIntegration.IntegrationType)}
                    options={IntegrationTypes}
                    defaultValue={IntegrationTypes[0].value}
                    disabled={viewOnly}
                    rules={{ required: true }}
                />
            </FormRow>
            <FormRow>
                <ValidationErrors name={DESCRIPTION_GENERAL_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(CallRecIntegration.ModifyCallRecIntegrationDescriptionFormLabel)}
                        inputName={DESCRIPTION_GENERAL_NAME}
                        disabled={viewOnly}
                    />
                </ValidationErrors>
            </FormRow>
        </div>
    )
}

export default General
